/**
 * 权限定义
 */
const ACCESS_ENUM = {
  NOT_LOGIN: "notLogin",
  USER: "user",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
};

export default ACCESS_ENUM;
